<template>
    <div class="timing-hall-base-table__box box">
        <table class="timing-hall-base-table__table timing-hall-base-table__table_striped timing-hall-base-table__table_hover">
            <col class="timing-hall-base-table__column"
                v-for="column in columns"
                :key="column.id"
                :class="`timing-hall-base-table__column_${column.id}`"
            >
            <thead>
                <timing-hall-base-table-head-row :columns="columns" />
            </thead>
            <tbody>
                <timing-hall-base-table-body-row
                    v-if="totalRow"
                    class="timing-hall-base-table__row_pinned"
                    :columns="columns"
                    :row="totalRow"
                />
                <timing-hall-base-table-body-row
                    v-for="row in rows"
                    :key="row.id"
                    :columns="columns"
                    :row="row"
                    :compareRow="totalRow"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
    import TimingHallBaseTableHeadRow from "./TimingHallBaseTableHeadRow";
    import TimingHallBaseTableBodyRow from "./TimingHallBaseTableBodyRow";

    export default {
        name: "TimingHallBaseTable",
        components: {
            TimingHallBaseTableHeadRow,
            TimingHallBaseTableBodyRow,
        },
        props: {
            columns: {
                type: Array,
                required: true
            },
            totalRow: {
                type: Object,
            },
            rows: {
                type: Array,
                required: true
            }
        },
    };
</script>

<style lang="scss">
    .timing-hall-base-table__box {
        padding: 16px;
        overflow-x: auto;
    }
    .timing-hall-base-table__table {
        width: 100%;
    }
    .timing-hall-base-table__column {
        &_title {
            width: 25%;
        }

        &_dish_group {
            width: 18%;
        }
    }
    .timing-hall-base-table__row {
        &_body {
            .timing-hall-base-table__table_striped &:nth-of-type(odd) {
                background-color: $background-gray-primary;
            }

            .timing-hall-base-table__table_hover &:hover {
                background-color: $gray-form;
            }
        }

        &_pinned {
            background-color: $gray-form !important;
        }
    }
    .timing-hall-base-table__cell {
        font-size: 20px;
        padding: 12px 8px;

        &_head {
            padding: 8px;
            white-space: nowrap;
        }

        &_sortable {
            cursor: pointer;
        }

        &_title {
            font-weight: bold;
        }

        &_tar {
            text-align: right;
        }
    }
    .timing-hall-base-table__cell-content {
        display: grid;
        grid-gap: 5px;

        &_columns {
            grid-auto-flow: column;
            align-items: center;

            &.timing-hall-base-table__cell-content_left {
                justify-content: start;
            }

            &.timing-hall-base-table__cell-content_right {
                justify-content: end;
            }
        }

        &_rows {
            grid-auto-flow: row;

            &.timing-hall-base-table__cell-content_left {
                justify-items: start;
            }

            &.timing-hall-base-table__cell-content_right {
                justify-items: end;
            }
        }
    }
    .timing-hall-base-table__value {
        &_icon {
            width: 16px;
            height: 16px;
        }
    }
</style>
